import * as React from "react";
const SvgFiRrKaaba = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-kaaba_svg__a)">
      <path
        fill="#062147"
        d="M11 15.467v.03a.987.987 0 0 1-1.449.872l-2.026-1.074A.99.99 0 0 1 7 14.423v-.03a.987.987 0 0 1 1.449-.872l2.026 1.074a.99.99 0 0 1 .525.872m4.565-1.883-2.026 1.034a.99.99 0 0 0-.538.879v.048a.987.987 0 0 0 1.435.879l2.026-1.034a.99.99 0 0 0 .538-.88v-.047a.987.987 0 0 0-1.435-.88M23 8.18v7.64a4.99 4.99 0 0 1-2.658 4.418l-6.001 3.18a5 5 0 0 1-4.683 0l-5.999-3.18A4.99 4.99 0 0 1 1 15.82V8.18a4.99 4.99 0 0 1 2.658-4.418L9.659.582a5 5 0 0 1 4.683 0l5.999 3.18A4.99 4.99 0 0 1 23 8.18M3.337 6.81l7.258 3.84a3 3 0 0 0 2.81 0l7.259-3.84a3 3 0 0 0-1.259-1.282l-5.999-3.18a3 3 0 0 0-2.809 0l-6.001 3.18a3 3 0 0 0-1.258 1.283zM21 15.82V12.93l-.53.298a.987.987 0 1 1-.966-1.721l1.496-.84V8.896l-6.659 3.522a5 5 0 0 1-4.683 0L3 8.895v1.722l1.48.796c.32.172.52.506.52.869v.025a.987.987 0 0 1-1.453.87L3 12.884v2.936c0 1.114.611 2.129 1.596 2.65l5.999 3.18a3 3 0 0 0 2.81 0l6.001-3.18A2.99 2.99 0 0 0 21 15.819"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-kaaba_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKaaba;
